export default __webpack_public_path__ + "static/media/laundry2-before.fd5a994a.jpg";